export const noCoesEscalation = {
  description: 'Patient does not have COEs available.',
  escalationType: 'no_coes_found',
  escalationStatus: 'active',
  exceptionStatus: 'not_applicable',
  exceptionType: null,
};
